import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.recharge;
export const DEFAULT_QUERY_DATA = {
    Currency: null,
    FromAddress: null,
    ToAddress: null,
    NetworkId: null,
    Status: null,
    TxId: null,
}

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { networkTypeOptions, statusOptions }  = props;
    return [
        {
            title: "转出地址",
            type: "input",
            field: "FromAddress",
            allowClear: true,
        },
        {
            title: "转入地址",
            type: "input",
            field: "ToAddress",
            allowClear: true,
        },
        {
            title: "币种",
            type: "select",
            field: "Currency",
            options: [
                { id: "USDT", name: "USDT" },
                { id: "USDC", name: "USDC" },
            ],
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "交易网络",
            type: "select",
            field: "NetworkId",
            options: networkTypeOptions,
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "状态",
            type: "select",
            field: "Status",
            allowClear: true,
            options: statusOptions,
            style: {
                width: 200
            }
        },
        {
            title: "hash值",
            type: "input",
            field: "TxId",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "id",
            dataIndex: "Id",
        },
        {
            title: "转账网络",
            dataIndex: "Network",
        },
        {
            title: "币种",
            dataIndex: "Currency",
        },
        {
            title: "转账金额",
            dataIndex: "Amount",
        },
        {
            title: "转出地址",
            dataIndex: "FromAddress",
        },
        {
            title: "转入地址",
            dataIndex: "ToAddress",
        },
        {
            title: "交易hash",
            dataIndex: "TxId",
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
        },
    ]
}